// extracted by mini-css-extract-plugin
export default {"completedPanelContainer":"completed-panel_completedPanelContainer__TdwXn","heading":"completed-panel_heading__Ybg7b","attention":"completed-panel_attention__xRGqT"};